import { message } from 'antd'
import Context from '../Context'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import useLogAction from 'hooks/useLogAction'

const closeTicket = async ({ id,
  email,
  phone,
  name,
  type,
  sdk_version,
}) => {
  const { data } = await axiosRequest({
    url: `/support/admin/${id}`,
    method: 'PATCH',
    data: {

      status: 'Cerrado'
    }
  })

  return data
}

const useManageTicket = setPopOpen => {
  const { logAction } = useLogAction()
  const {
    queryHandler: { data },
    states: { page },
    actions: { setDirtyBit, setPage }
  } = useContext(Context)

  const paginationInfo = get(data, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 7,
    totalPages: 1,
    totalRecords: 1
  })

  const { isLoading, isError, mutate } = useMutation({
    mutationKey: 'close-ticket',
    mutationFn: closeTicket,
    onSuccess: () => {
      const { totalRecords, currentPage, totalPages } = paginationInfo
      setPopOpen(false)

      if (
        currentPage > Math.ceil((totalRecords - 1) / 9) &&
        currentPage !== 1
      ) {
        setPage(page - 1)
      } else setDirtyBit(true)

      message.success({
        type: 'success',
        content: 'Acción realizada con exito'
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = (record) => {
    mutate(record, {
      onSuccess: () => {
        const { id,
          email,
          phone,
          name,
          type,
          sdk_version } = record
        logAction({
          event: "TICKET", action: "UPDATE", metadata: {
            actionType: "supportTicketClosed",
            ticket: {
              id,
              email,
              phone,
              name,
              type,
              sdk_version
            }
          }
        })
      }
    })
  }

  return {
    isLoading,
    isError,
    onClick
  }
}

export default useManageTicket
